import React from 'react';
import useNavState from 'shared/hooks/useNavState';
import Game from './Game';

// Screens that hide the bottom bar with useNavState show it again in their effect cleanup. Since React 17 that
// cleanup runs in the passive phase, after Game's componentDidMount when one screen replaces the other.
// Claiming the bar from an effect too orders it after those cleanups (unmount effects flush before mount effects).
export default function GameScreen(props) {
  useNavState();
  return <Game {...props} />;
}
